import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { FileDownloadService } from '../../../commons/kymw02/file-download-confirm/file-download.service';
import { KYMW4101Component } from './kymw4101.component';

import { OutputKomaSizeDifferenceListService } from './api-services/output-koma-size-difference-list.service';


/**
 * 媒体間コマサイズ差分リスト画面 モジュール設定クラス
 *
 * @export KYMW4101Module
 * @class KYMW4101Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
  ],
  declarations: [
    KYMW4101Component,
  ],
  providers: [
    FileDownloadService,
    OutputKomaSizeDifferenceListService,
  ],
})
export class KYMW4101Module {
}
